/*
Gumroad tutorial: https://0xca0a.gumroad.com/l/B4N4N4S
-------------------------------------------------------------------------------
Model auto-generated by: https://github.com/pmndrs/gltfjsx
Author: thesidekick (https://sketchfab.com/thesidekick)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/banana-dda3a1f707a94c52bed79578e120937c
Title: Banana
*/

import { createRoot } from 'react-dom/client'
import { Suspense, useState } from 'react'
import './styles.css'
import { ThemeProvider } from 'styled-components'
import Overlay from './layout/Overlay'
import { FadeIn, LeftMiddle, lightTheme, darkTheme, GlobalStyle } from './layout/styles'

import Bananas from './Bananas'
// Comment the above and uncomment the following to import the WebGL BG lazily for faster loading times
// const Bananas = lazy(() => import('./Bananas'))

function App() {
  const [speed, set] = useState(1)
  const [themeMode, setThemeMode] = useState('light')
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const theme = themeMode === 'light' ? lightTheme : darkTheme

  const toggleTheme = () => {
    setThemeMode(prev => prev === 'light' ? 'dark' : 'light')
  }

  require('react').useEffect(() => {
    const themeColor = themeMode === 'light' ? '#ffbf40' : '#0d0d0d'
    let meta = document.querySelector('meta[name="theme-color"]')
    if (meta) meta.setAttribute('content', themeColor)
    document.documentElement.style.backgroundColor = themeColor
    document.body.style.backgroundColor = themeColor
  }, [themeMode])

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Suspense fallback={null}>
        <Bananas speed={speed} themeMode={themeMode} />
        <FadeIn />
      </Suspense>
      <Overlay
        themeMode={themeMode}
        toggleTheme={toggleTheme}
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
      />
      <LeftMiddle style={{ opacity: isMenuOpen ? 0 : 1, pointerEvents: isMenuOpen ? 'none' : 'auto' }}>
        <input type="range" min="0" max="10" value={speed} step="1" onChange={(e) => set(e.target.value)} />
      </LeftMiddle>
    </ThemeProvider>
  )
}

createRoot(document.getElementById('root')).render(<App />)
